
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class SpinnerComponent extends Vue {
  @Prop({ type: Number, default: 24 }) width: number;
  @Prop({ type: String, default: 'var(--blue-color)' }) color: string;
}
